import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import api, { formatApiError } from "./api";

const INPUT = "bg-transparent border-b border-[#333333] focus:border-[#D4AF37] text-white py-3 px-2 w-full outline-none transition-colors duration-300";

export const SettingsPanel = ({ user }) => {
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.next !== form.confirm) return toast.error("New passwords do not match.");
    if (form.next.length < 8) return toast.error("New password must be at least 8 characters.");
    setLoading(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current,
        new_password: form.next,
      });
      toast.success("Password updated — use it next time you sign in.");
      setForm({ current: "", next: "", confirm: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg" data-testid="settings-panel">
      <div className="bg-[#111111] border border-[#333333] p-8">
        <p className="text-[11px] uppercase tracking-[0.25em] text-[#D4AF37] flex items-center gap-2 mb-2">
          <KeyRound className="h-4 w-4" /> Change Password
        </p>
        <p className="text-xs text-gray-500 mb-8">
          Signed in as <span className="text-gray-300">{user.email}</span>. Choose something memorable —
          it replaces your current password immediately.
        </p>
        <form onSubmit={submit} className="space-y-7" data-testid="change-password-form">
          <div>
            <label className="text-[11px] uppercase tracking-[0.2em] text-gray-400">Current Password</label>
            <input required type="password" className={INPUT} data-testid="settings-current-password"
              value={form.current} onChange={(e) => setForm({ ...form, current: e.target.value })} />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-[0.2em] text-gray-400">New Password</label>
            <input required type="password" minLength={8} className={INPUT} data-testid="settings-new-password"
              value={form.next} onChange={(e) => setForm({ ...form, next: e.target.value })} />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-[0.2em] text-gray-400">Confirm New Password</label>
            <input required type="password" minLength={8} className={INPUT} data-testid="settings-confirm-password"
              value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} />
          </div>
          <button type="submit" disabled={loading} data-testid="settings-save-password-btn"
            className="inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-[#050505] hover:bg-[#C9A227] transition-colors duration-300 px-8 py-3 uppercase tracking-widest text-sm font-semibold disabled:opacity-60">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            {loading ? "Saving..." : "Update Password"}
          </button>
        </form>
      </div>
    </div>
  );
};
